import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, CheckCircle2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FeaturedTreatments() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 md:py-24 bg-brand-dark text-white relative" data-id="element-77" data-mp="2afpfb543n9gr">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78" data-mp="2egrh9tpehzmf">
        <div className="text-center mb-10 md:mb-16" data-id="element-79" data-mp="325aoe5wps6cx">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-80" data-mp="325tw6tsnhed8">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-gold-light mb-4 md:mb-6" data-id="element-81" data-mp="2y3p4i0lrirt8">
              {t('featured.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-82" data-mp="1honvgqpgopqw"></div>
          </motion.div>
        </div>

        {/* Hero Treatment: Acne */}
        <motion.div className="bg-white/5 border border-brand-gold/30 p-8 md:p-12 rounded-sm mb-12 relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-83" data-mp="rl1zgvrkr4yv">
          <div className="btn-gold-animated absolute top-0 right-0 overflow-hidden text-white px-6 py-2 rounded-bl-lg font-bold text-sm tracking-wider flex items-center gap-2" data-id="element-84" data-mp="wj3jbiwtr8be">
            <span aria-hidden="true" className="sheen pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 skew-x-[-20deg] bg-white/25 blur-md" data-id="element-85" data-mp="15lcr410pknl3" />
            <Trophy className="relative w-4 h-4" data-id="element-86" data-mp="1k8xpjhmn1ymo" />
            <span className="relative" data-id="element-87" data-mp="1fa3222dq7lw8">{t('featured.badge')}</span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-88" data-mp="1ta4b45459zms">
            <div data-id="element-89" data-mp="1t8b2wldvv7co">
              <h3 className="text-3xl font-serif text-brand-gold-light mb-4 mt-4 lg:mt-0" data-id="element-90" data-mp="1p8sj5sxst2bf">
                {t('featured.hero_title')}
              </h3>
              <p className="text-gray-300 mb-6 text-lg" data-id="element-91" data-mp="1wdbgw8rofk3a">
                {t('featured.hero_desc')}
              </p>

              <div className="mb-6" data-id="element-92" data-mp="21bczksl6xhe8">
                <h4 className="text-white font-semibold mb-2" data-id="element-93" data-mp="26ag84n0dq5qy">
                  {t('featured.who_title')}
                </h4>
                <p className="text-gray-400 text-sm" data-id="element-94" data-mp="2b1y8b8ukw2av">
                  {t('featured.who_desc')}
                </p>
              </div>

              <div className="flex flex-wrap gap-4 text-sm text-gray-300" data-id="element-95" data-mp="2f4kt4psu0myk">
                <div className="bg-black/30 px-4 py-2 rounded-sm border border-white/10" data-id="element-96" data-mp="2k09u8xki2bwz">
                  <span className="text-brand-gold font-semibold" data-id="element-97" data-mp="2p1pfapmogifd">
                    {t('featured.duration_label')}
                  </span>{' '}
                  {t('featured.duration_val')}
                </div>
                <div className="bg-black/30 px-4 py-2 rounded-sm border border-white/10" data-id="element-98" data-mp="uo7rr2m9vlkc">
                  <span className="text-brand-gold font-semibold" data-id="element-99" data-mp="zmj3xk01i85q">
                    {t('featured.freq_label')}
                  </span>{' '}
                  {t('featured.freq_val')}
                </div>
              </div>

              {/* Before / After Visual */}
              <motion.figure className="mt-8 group relative overflow-hidden rounded-sm border border-brand-gold/30 bg-black/40" initial={{
              opacity: 0,
              y: 30,
              scale: 0.97
            }} whileInView={{
              opacity: 1,
              y: 0,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.3
            }} transition={{
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-100" data-mp="342wc08jscz5n">
                <img src="https://cdn.magicpatterns.com/uploads/tmPPunK7nK7BhbpR7tn2JN/TRATAMIENTO_PARA_EL_ACNE.png" alt="Resultado real de tratamiento para el acné: antes y después" loading="lazy" className="w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" data-id="element-101" data-mp="3hvvp63w3iha1" />

                {/* Center divider */}
                <div className="pointer-events-none absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-brand-gold/70" data-id="element-102" data-mp="3ubbutqahewxi"></div>

                {/* Antes / Después labels */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-between p-3 text-[10px] md:text-xs font-semibold uppercase tracking-widest text-white" data-id="element-103" data-mp="3ld8auyf5a87t">
                  <span className="bg-black/60 border border-white/10 px-3 py-1 rounded-sm" data-id="element-104" data-mp="huylgk2m1404">
                    Antes
                  </span>
                  <span className="bg-brand-gold/90 px-3 py-1 rounded-sm" data-id="element-105" data-mp="lupih5iqcgd3">
                    Después
                  </span>
                </div>

                {/* Animated gold shine sweep */}
                <motion.div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/25 to-transparent" initial={{
                x: '-50%',
                opacity: 0
              }} whileInView={{
                x: '450%',
                opacity: 1
              }} viewport={{
                once: true,
                amount: 0.3
              }} transition={{
                duration: 1.6,
                delay: 0.5,
                ease: 'easeInOut'
              }} data-id="element-106" data-mp="cy86k02jkega" />
              </motion.figure>
            </div>

            <div data-id="element-107" data-mp="2u4yehmjbo9u1">
              <h4 className="text-white font-semibold mb-4 text-xl" data-id="element-108" data-mp="2u2c65kolxqar">
                {t('featured.achieve_title')}
              </h4>
              <ul className="space-y-4" data-id="element-109" data-mp="22dslrr5xlees">
                {[t('featured.achieve_1'), t('featured.achieve_2'), t('featured.achieve_3'), t('featured.achieve_4'), t('featured.achieve_5')].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-110" data-mp="2be79ex6db5lg" data-mpi={idx}>
                    <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-111" data-mp="2bbuihuimtkw9" />
                    <span className="text-gray-300" data-id="element-112" data-mp="1nmjrh4r334vb">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Other Featured */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-113" data-mp="3iqzuhx4w69cx">
          {[{
          title: t('featured.t1_title'),
          desc: t('featured.t1_desc')
        }, {
          title: t('featured.t2_title'),
          desc: t('featured.t2_desc')
        }, {
          title: t('featured.t3_title'),
          desc: t('featured.t3_desc')
        }, {
          title: t('featured.t4_title'),
          desc: t('featured.t4_desc')
        }].map((item, idx) => <motion.div key={idx} className="bg-white/5 border border-white/10 p-6 rounded-sm hover:border-brand-gold/50 transition-colors" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3 + idx * 0.1
        }} data-id="element-114" data-mp="34qykns6nfrlb" data-mpi={idx}>
              <h4 className="text-xl font-serif text-brand-gold-light mb-3" data-id="element-115" data-mp="t1o1n8gjd3ad">
                {item.title}
              </h4>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-116" data-mp="2diyea3vvg0d8">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}